import { render, staticRenderFns } from "./ModalEditarModelo.vue?vue&type=template&id=8294a1c0"
import script from "./ModalEditarModelo.vue?vue&type=script&lang=js"
export * from "./ModalEditarModelo.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarModelo.vue?vue&type=style&index=0&id=8294a1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports